/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-test': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(3 3)" _fill="#000" fill-rule="nonzero"><path pid="0" d="M1.83 7.755l6.932-5.48a.383.383 0 01.472 0l6.932 5.48a1.145 1.145 0 001.583-.162 1.082 1.082 0 00-.167-1.546L10.65.567a2.69 2.69 0 00-3.304 0L.418 6.047A1.082 1.082 0 00.25 7.593a1.146 1.146 0 001.579.163z"/><path pid="1" d="M16 16.448v-5.43a1.774 1.774 0 00-.535-1.233L9.41 4.355a1.345 1.345 0 00-1.819 0L1.536 9.788A1.773 1.773 0 001 11.02v5.43c-.008.847.631 1.541 1.428 1.551h3.93c.398-.005.718-.352.714-.776v-4.266c-.004-.424.315-.771.714-.776h1.428c.399.005.718.352.714.776v4.266c-.004.424.316.771.715.776h3.929c.797-.01 1.436-.704 1.428-1.552z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-test.js